/* eslint-disable react/forbid-dom-props */
import React from 'react'

export const NotificationIcon: React.FC<{ fill?: string }> = ({
  fill = '#BCB1B0',
}) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24">
    <defs>
      <path
        id="notification_a"
        d="M9 20a2.5 2.5 0 002.499-2.5H6.5A2.5 2.5 0 008.999 20zm8.414-5.848c-.755-.811-2.167-2.03-2.167-6.027 0-3.035-2.128-5.465-4.998-6.06V1.25a1.249 1.249 0 10-2.499 0v.814C4.882 2.66 2.754 5.09 2.754 8.125c0 3.996-1.412 5.216-2.167 6.027A1.221 1.221 0 00.251 15c.004.64.507 1.25 1.254 1.25h14.992c.747 0 1.25-.61 1.254-1.25a1.221 1.221 0 00-.336-.848z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <g transform="translate(3 2)">
        <mask id="notification_b" fill="#fff">
          <use xlinkHref="#notification_a" />
        </mask>
        <g fill={fill} mask="url(#notification_b)">
          <path d="M-3-2h24v24H-3z" />
        </g>
      </g>
    </g>
  </svg>
)
